import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import { Card, CardContent } from "@babackapp/ui/components/card";
import useCustomCSS from "@babackapp/private-api-client/client/use-portal-custom-css";
import useUpdateCustomCSS from "@babackapp/private-api-client/client/use-update-portal-custom-css";
import { z } from "zod";
import CustomCSSForm from "./custom-css-form";

const CustomCSSFormSchema = z.object({
  customCSS: z.string(),
});

export type CustomCSSFormValues = z.infer<typeof CustomCSSFormSchema>;

export default function CustomCSSCard() {
  const { data: shop } = useCurrentShopSuspense();
  const { data: customCSS, isFetched } = useCustomCSS(shop);
  const { mutateAsync: updateCustomCSS } = useUpdateCustomCSS(shop);

  const onSubmit = (value: CustomCSSFormValues) => {
    return updateCustomCSS(value.customCSS);
  };

  if (!isFetched) return null;

  return (
    <Card className="w-full">
      <CardContent>
        <CustomCSSForm defaultValues={{ customCSS }} onSubmit={onSubmit} />
      </CardContent>
    </Card>
  );
}
